import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import LookListFeature from "../../../lookNavigation/lookMain/lookListFeature/lookListFeature";
import {getDisplaySameColorGroups} from "../../../lookNavigation/lookFunctions";
import {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import LookFeatureColorMatchCheckbox from "../../../lookNavigation/lookMain/lookFeature/lookFeatureColorMatchCheckbox";


const GroheSameColorFeaturesContent = (props) => {

  const {sameColorFeatures, currentColorFeatures, groheSameColorActiveFeature, filterGroups} = props;

  const displaySameColorGroups = getDisplaySameColorGroups(
    groheSameColorActiveFeature, [...sameColorFeatures, ...currentColorFeatures], filterGroups
  );

  return (
    <div className="grohe-same">
      <div className="grohe-same__header">
        <h3 className="grohe-same__header-title"><FormattedMessage id="grohe.sameColor.title"/></h3>
        <p className="grohe-same__header-sub-title">
          <FormattedMessage id="grohe.sameColor.subTitle"/>
        </p>
        <div className="gm-feature__checkbox">
          <LookFeatureColorMatchCheckbox currentColorFeatures={currentColorFeatures}
                                         sameColorFeatures={sameColorFeatures}
                                         analyticsLabel={PRODUCT_JOURNEY_ANALYTIC_EVENTS.productMatchColorsVisualizeAllCheckbox}/>
        </div>
      </div>
      <div className="grohe-same__list">
        {displaySameColorGroups.map(sameColorObject => (
          <div className="grohe-same__list-section" key={sameColorObject.colName}>
            <h4 className="grohe-same__list-section-title">
              <FormattedMessage id={`grohe.sameColor.section.${sameColorObject.colName === "other" ? "other" : "title"}`}
                                values={{collectionName: sameColorObject.colName}}/>
            </h4>
            {sameColorObject.features.map(sameColorFeature => {
              return <LookListFeature style={{}} lookFeature={sameColorFeature} key={sameColorFeature.dbFeature.id}/>
            })}
          </div>
        ))}
      </div>
    </div>
  )
};

GroheSameColorFeaturesContent.propTypes = {
  sameColorFeatures: PropTypes.array.isRequired,
  currentColorFeatures: PropTypes.array.isRequired,
};

const mapStateToProps = (store) => {
  const {groheSameColorActiveFeature} = store.groheState;
  const {filterGroups} = store.filterState;
  return {
    groheSameColorActiveFeature,
    filterGroups,
  };
};

export default connect(mapStateToProps)(GroheSameColorFeaturesContent)
